import React from "react";

export const DashboardIcon = ({
  isActive,
  opacity,
  ...props
}: SvgIconProps) => {
  return (
    <svg width={14} height={14} viewBox="0 0 14 14" fill="none" {...props}>
      <path
        d="M5.667 1H1v12h4.667V1zM13 1H8.333v5.5H13V1zM13 9H8.333v4H13V9z"
        stroke={isActive ? "#ffff" : "#214160"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity={opacity}
      />
    </svg>
  );
};
